import { $api } from "../generated/client";

type SizingDiagnosticParams = {
	shopId: string;
	fromTimestamp?: number;
	toTimestamp?: number;
	limit?: number;
	offset?: number;
};

export default function useSizingDiagnostic({
	shopId,
	...params
}: SizingDiagnosticParams) {
	return $api.useQuery("get", "/shops/{shopId}/sizing/diagnostic", {
		params: { path: { shopId }, query: params },
		enabled: !!shopId,
	});
}
